module.exports = __webpack_public_path__ + "img/hr-dead-tree-desert-06.39a26969.png";